export default __webpack_public_path__ + "bc93895c5bd12812e633171bc94e7107.svg";